import { createSelector } from 'reselect'
import _ from 'lodash'

import en from '../locales'
import jsonSelector from './json'

const transformTranslations = object =>
  _.reduce(object, (acc, value, key) => _.set(acc, [...key.split('.')], value), {})

const i18nLocaleSelector = state => state.i18n.locale
const i18nTranslationsSelector = state => state.i18n.translations
const translationsSelector = state => transformTranslations(jsonSelector('translations')(state))

export default createSelector(
  i18nLocaleSelector,
  i18nTranslationsSelector,
  translationsSelector,
  (locale, local, remote) => _.merge({}, { [locale]: en }, local, { [locale]: remote })
)



// WEBPACK FOOTER //
// ./src/selectors/translations.js